import { render, staticRenderFns } from "./Advert.vue?vue&type=template&id=ba3be76e&scoped=true"
import script from "./Advert.vue?vue&type=script&lang=js"
export * from "./Advert.vue?vue&type=script&lang=js"
import style0 from "./Advert.vue?vue&type=style&index=0&id=ba3be76e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3be76e",
  null
  
)

export default component.exports